import css from 'styled-jsx/css'

export const bannerStyles = css`
  .banner-container .title {
    margin-top: 0rem;
  }
  .banner {
    display: flex;
  }
  .banner img {
    max-width: 5rem;
    max-height: 4rem;
    padding-right: 1rem;
  }
  .banner .subtitle {
    margin: 0.2rem 0 0.5rem;
  }
  .banner .description {
    margin-top: 0;
  }
`
